module.exports = __webpack_public_path__ + "media/bootstrap-icons/sunglasses-2d012dd5.svg";